__turbopack_context__.v({
  "author": "style-module-scss-module__Fg2Sra__author",
  "author-info": "style-module-scss-module__Fg2Sra__author-info",
  "component": "style-module-scss-module__Fg2Sra__component",
  "container": "style-module-scss-module__Fg2Sra__container",
  "image-wrapper": "style-module-scss-module__Fg2Sra__image-wrapper",
  "spacer": "style-module-scss-module__Fg2Sra__spacer",
});
